// material
import { Box, Grid, Container, Typography, Select, FormControl, InputLabel, MenuItem } from '@mui/material';
// components
import Page from '../components/Page';
import {
  AppTasks,
  AppNewUsers,
  AppBugReports,
  AppItemOrders,
  AppNewsUpdate,
  AppWeeklySales,
  AppOrderTimeline,
  AppCurrentVisits,
  AppWebsiteVisits,
  AppChart,
  AppTrafficBySite,
  AppCurrentSubject,
  AppConversionRates,
  AppBarChart
} from '../components/_dashboard/app';

import { useRequireAuth } from "../components/common/use-require-auth.js";
import Loading from "../components/common/loading.js";
import { useEffect, useState } from 'react';
import Request from '../components/common/Request';
import Filter, { GetFilterData } from '../components/Filter';
import MultiChart from '../components/_dashboard/app/MultiChart';

import {  useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------

export default function DashboardApp() 
{

  const [filterData, setFilterData] = useState(GetFilterData());

  var isAuth = useRequireAuth();
  
  const {t} = useTranslation();

  if (!isAuth){
    return <Loading></Loading>
  }

  
  return (
    <Page title="Dashboard" className="main">
      <Container maxWidth="xxl">
        {/* <Box sx={{ pb: 5 }}>
          <Typography variant="h4">{t("welcomeBack")}</Typography>
        </Box> */}

        <Grid container spacing={3}>

          
          
          <Grid item xs={12} sm={12} md={12}>
            <Filter data={filterData} setData={setFilterData} ></Filter>
          </Grid>
          
         
          {/* <Grid item xs={12} sm={6} md={3}>
            <AppWeeklySales />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <AppNewUsers />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <AppItemOrders />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppBugReports />
          </Grid>
           */}

          <MultiChart filterData={filterData}  />



{/* 
          <Grid item xs={12} md={6} lg={8}>
            <AppWebsiteVisits />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppCurrentVisits />
          </Grid>

          <Grid item xs={12} md={6} lg={8}>
            <AppConversionRates />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppCurrentSubject />
          </Grid>

          <Grid item xs={12} md={6} lg={8}>
            <AppNewsUpdate />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppOrderTimeline />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppTrafficBySite />
          </Grid>

          <Grid item xs={12} md={6} lg={8}>
            <AppTasks />
          </Grid> */}
        </Grid>
      </Container>
    </Page>
  );
}
